import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';

export class FormRelationalValidators {
  static matchControls(
    checkControlName = 'password',
    confirmControlName = 'confirmPassword'
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const checkControl = control.get(checkControlName);
      const confirmControl = control.get(confirmControlName);

      if (!checkControl || !confirmControl) {
        return null;
      }

      // Prevent overwriting other errors on confirmControl
      if (confirmControl.errors && !confirmControl.errors['valueMismatch']) {
        return null;
      }

      if (checkControl.value !== confirmControl.value) {
        confirmControl.setErrors({ valueMismatch: true });
      } else {
        confirmControl.setErrors(null);
      }

      return null;
    };
  }

  static atLeastOneTrue(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control as FormGroup;

      if (!formGroup || !formGroup.controls) {
        return null;
      }

      const values = Object.values(formGroup.controls).map((c) => c.value);

      const allAreFalse =
        values.length > 0 && values.every((value) => value === false);

      return allAreFalse ? { allFalse: true } : null;
    };
  }
}
